/**
 * Boja statusa štete iz baze → hex. Koristi se tamo gdje boja ide u stil, a ne u klasu:
 * točke na fotografiji i kružić uz status u dropdownu.
 */
export const DAMAGE_STATUS_HEX: Record<string, string> = {
  orange: "#f97316",
  blue: "#3b82f6",
  green: "#22c55e",
  slate: "#64748b",
};

export const DEFAULT_DAMAGE_STATUS_HEX = "#f97316";
